"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _search = _interopRequireDefault(require("material-ui/svg-icons/action/search"));
var _clear = _interopRequireDefault(require("material-ui/svg-icons/content/clear"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
require("./CardBrowserSearch.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var CardBrowserSearch = /*#__PURE__*/function (_Component) {
  _inherits(CardBrowserSearch, _Component);
  var _super = _createSuper(CardBrowserSearch);
  function CardBrowserSearch(props) {
    var _this;
    _classCallCheck(this, CardBrowserSearch);
    _this = _super.call(this, props);
    _this.state = {
      value: _this.props.search ? _this.props.search : '',
      focused: _this.props.search ? true : false
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleClearButtonClick = _this.handleClearButtonClick.bind(_assertThisInitialized(_this));
    _this.handleSearchButtonClick = _this.handleSearchButtonClick.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(CardBrowserSearch, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.value !== nextProps.search) {
        this.setState({
          value: nextProps.search
        });
      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.handleSearchDebounced = (0, _debounce2["default"])(function () {
        this.props.action.apply(this, [this.state.value]);
      }, 1000);
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.setState({
        value: event.target.value
      });
      this.handleSearchDebounced();
    }
  }, {
    key: "handleSearchButtonClick",
    value: function handleSearchButtonClick(event) {
      event.preventDefault();
      event.stopPropagation();
      var newState = this.state;
      newState.focused = true;
      this.setState(newState);
      document.getElementById("search-input-field").focus();
    }
  }, {
    key: "handleClearButtonClick",
    value: function handleClearButtonClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({
        value: '',
        focused: false
      });
      this.props.action('');
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      event.preventDefault();
      event.stopPropagation();
      var newState = this.state;
      newState.focused = this.state.value ? true : false;
      this.setState(newState);
    }
  }, {
    key: "render",
    value: function render() {
      var iconStyles = {
        clear: {
          "float": "right",
          marginRight: 0,
          marginTop: 0,
          color: "#2E2E2E",
          cursor: "pointer",
          height: 24,
          width: 24
        },
        search: {
          "float": "left",
          marginLeft: 0,
          marginTop: 0,
          height: 24,
          width: 24,
          color: this.props.iconColor,
          cursor: "pointer"
        }
      };
      var cardSearchStyle = {
        color: this.props.cardSearchColor,
        height: this.props.cardSearchHeight,
        minWidth: this.props.cardSearchMinWidth
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-browser-search ".concat(this.state.focused ? 'focused' : ''),
        style: cardSearchStyle,
        onClick: this.handleSearchButtonClick
      }, /*#__PURE__*/_react["default"].createElement(_search["default"], {
        className: "search-icon",
        style: iconStyles.search
      }), /*#__PURE__*/_react["default"].createElement("input", {
        className: "search-input ".concat(this.state.value.length > 0 ? 'with-value' : ''),
        onChange: this.handleChange,
        placeholder: "Search",
        onBlur: this.handleBlur,
        id: "search-input-field",
        value: this.state.value
      }), this.state.value.length > 0 ? /*#__PURE__*/_react["default"].createElement(_clear["default"], {
        className: "clear-icon",
        style: iconStyles.clear,
        onClick: this.handleClearButtonClick
      }) : null);
    }
  }]);
  return CardBrowserSearch;
}(_react.Component);
CardBrowserSearch.defaultProps = {
  action: [],
  search: '',
  iconColor: 'rgba(255, 255, 255, 0.7)',
  cardSearchColor: 'rgba(255, 255, 255, 0.30)',
  cardSearchHeight: 44,
  cardSearchMinWidth: 400
};
CardBrowserSearch.propTypes = {
  action: _propTypes["default"].func,
  search: _propTypes["default"].string,
  // Styles
  iconColor: _propTypes["default"].string,
  cardSearchColor: _propTypes["default"].string,
  cardSearchHeight: _propTypes["default"].number,
  cardSearchMinWidth: _propTypes["default"].number
};
var _default = CardBrowserSearch;
exports["default"] = _default;